// // export default ReferralPage;
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../AuthProvider";
// import { db } from "../firebase";
// import { doc, getDoc } from "firebase/firestore";
// import { getDirectReferrals } from "../utils/referrals";

// const ReferralPage = () => {
//   const { user, authLoading } = useAuth();
//   const [userData, setUserData] = useState(null);
//   const [downlines, setDownlines] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [copied, setCopied] = useState(false);

//   useEffect(() => {
//     if (authLoading) return;
//     if (!user) {
//       setLoading(false);
//       return;
//     }

//     const fetchData = async () => {
//       const ref = doc(db, "referral_users", user.uid);
//       const snap = await getDoc(ref);
//       if (!snap.exists()) {
//         setUserData(null);
//         setLoading(false);
//         return;
//       }
//       const userDoc = snap.data();
//       setUserData(userDoc);

//       // Fetch level 1 (direct) referrals
//       const level1 = await getDirectReferrals(userDoc.referralCode);

//       // Fetch level 2 (indirect) referrals
//       let level2 = [];
//       for (let l1 of level1) {
//         const l2 = await getDirectReferrals(l1.referralCode);
//         level2 = level2.concat(l2);
//       }

//       // Fetch level 3 (third-level) referrals
//       let level3 = [];
//       for (let l2 of level2) {
//         const l3 = await getDirectReferrals(l2.referralCode);
//         level3 = level3.concat(l3);
//       }

//       setDownlines([
//         ...level1.map((u) => ({ ...u, level: 1 })),
//         ...level2.map((u) => ({ ...u, level: 2 })),
//         ...level3.map((u) => ({ ...u, level: 3 })),
//       ]);
//       setLoading(false);
//     };
//     fetchData();
//   }, [user, authLoading]);

//   if (authLoading) return <div className="p-8">Loading authentication…</div>;
//   if (!user)
//     return <div className="p-8 text-red-600">Please login to continue</div>;
//   if (loading) return <div className="p-8">Loading user data…</div>;
//   if (!userData) return <div className="p-8 text-red-600">User not found</div>;

//   const { referralCode, level = 1 } = userData;
//   const referralLink = `${window.location.origin}/register?ref=${referralCode}`;

//   const handleCopyLink = () => {
//     navigator.clipboard.writeText(referralLink);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-[#B721FF] via-[#21D4FD] to-[#21D4FD]/90"
//       style={{
//         minHeight: "100vh",
//       }}
//     >
//       <div className="w-full max-w-5xl bg-white/80 shadow-2xl rounded-3xl p-8 md:p-12 flex flex-col items-center border border-white/20">
//         <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A237E] mb-4 text-center drop-shadow-lg">
//           Your Sales Agent Dashboard
//         </h2>
//         <div className="mb-6 flex flex-col md:flex-row w-full items-center gap-4">
//           <div className="flex-1 flex flex-col items-center md:items-start">
//             <div className="flex items-center gap-3">
//               <span className="px-4 py-1 rounded-xl bg-[#B721FF]/10 text-[#B721FF] font-bold text-base">
//                 Referral Level {level}
//               </span>
//               <span className="font-semibold text-gray-800">
//                 Referral Code:
//               </span>
//               <span className="px-3 py-1 bg-gray-100 rounded-lg font-mono text-lg text-blue-800">
//                 {referralCode}
//               </span>
//             </div>
//           </div>
//           {userData.status === "approved" && level < 3 && (
//             <div className="flex-1 flex flex-col md:items-end items-center w-full">
//               <div className="font-semibold text-gray-700 mb-1">
//                 Your Sales Agent Link:
//               </div>
//               <div className="flex items-center gap-2 w-full max-w-md">
//                 <input
//                   className="w-full px-3 py-2 border rounded-xl font-mono bg-gray-100"
//                   value={referralLink}
//                   readOnly
//                 />
//                 <button
//                   onClick={handleCopyLink}
//                   className="px-4 py-2 bg-gradient-to-r from-[#B721FF] to-[#21D4FD] text-white rounded-xl font-bold shadow hover:opacity-80"
//                   type="button"
//                 >
//                   {copied ? "Copied!" : "Copy"}
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//         {userData.status !== "approved" && level < 3 && (
//           <div className="mb-6 text-yellow-600 font-bold text-center">
//             Your KYC is not approved yet.
//             <br />
//             <span className="text-gray-700 font-normal">
//               Please wait for admin approval to get your referral link.
//             </span>
//           </div>
//         )}
//         {level >= 3 && (
//           <div className="mb-6 text-yellow-600 font-bold text-center">
//             You have reached Level 3.
//             <br />
//             <span className="text-gray-700 font-normal">
//               You can’t invite new users, but you can still sell products!
//             </span>
//           </div>
//         )}

//         <div className="w-full mt-4">
//           <h4 className="text-lg font-bold mb-2 text-[#B721FF]">
//             Your Sales Agents
//           </h4>
//           <div className="rounded-2xl shadow bg-white/90 p-3 overflow-x-auto min-h-[180px]">
//             {downlines.length === 0 ? (
//               <div className="text-gray-400 text-center py-6">
//                 No downline users yet.
//               </div>
//             ) : (
//               <table className="w-full text-sm">
//                 <thead>
//                   <tr className="text-[#B721FF] font-bold">
//                     <th className="py-2 px-3 text-left">Name</th>
//                     <th className="py-2 px-3">Email</th>
//                     <th className="py-2 px-3 text-center">Level</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {downlines.map((u, idx) => (
//                     <tr key={idx} className="border-b last:border-b-0">
//                       <td className="py-2 px-3">{u.fullName}</td>
//                       <td className="py-2 px-3">{u.email}</td>
//                       <td className="py-2 px-3 text-center">{u.level}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReferralPage;

// // export default ReferralPage;
// import React, { useState, useEffect } from "react";
// import { useAuth } from "../AuthProvider";
// import { db } from "../firebase";
// import { doc, getDoc } from "firebase/firestore";
// import { getDirectReferrals } from "../utils/referrals";

// const ReferralPage = () => {
//   const { user, authLoading } = useAuth();
//   const [userData, setUserData] = useState(null);
//   const [downlines, setDownlines] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [copied, setCopied] = useState({ agent: false, instructor: false });

//   useEffect(() => {
//     if (authLoading) return;
//     if (!user) {
//       setLoading(false);
//       return;
//     }

//     const fetchData = async () => {
//       const ref = doc(db, "referral_users", user.uid);
//       const snap = await getDoc(ref);
//       if (!snap.exists()) {
//         setUserData(null);
//         setLoading(false);
//         return;
//       }
//       const userDoc = snap.data();
//       setUserData(userDoc);

//       // Fetch level 1 (direct) referrals
//       const level1 = await getDirectReferrals(userDoc.referralCode);

//       // Fetch level 2 (indirect) referrals
//       let level2 = [];
//       for (let l1 of level1) {
//         const l2 = await getDirectReferrals(l1.referralCode);
//         level2 = level2.concat(l2);
//       }

//       // Fetch level 3 (third-level) referrals
//       let level3 = [];
//       for (let l2 of level2) {
//         const l3 = await getDirectReferrals(l2.referralCode);
//         level3 = level3.concat(l3);
//       }

//       setDownlines([
//         ...level1.map((u) => ({ ...u, level: 1 })),
//         ...level2.map((u) => ({ ...u, level: 2 })),
//         ...level3.map((u) => ({ ...u, level: 3 })),
//       ]);
//       setLoading(false);
//     };
//     fetchData();
//   }, [user, authLoading]);

//   if (authLoading) return <div className="p-8">Loading authentication…</div>;
//   if (!user)
//     return <div className="p-8 text-red-600">Please login to continue</div>;
//   if (loading) return <div className="p-8">Loading user data…</div>;
//   if (!userData) return <div className="p-8 text-red-600">User not found</div>;

//   const { referralCode, level = 1, status } = userData;

//   const referralLink = `${window.location.origin}/register?ref=${referralCode}`;

//   const instructorReferralLink = `https://instructor.txtrademart.online/register?ref=${referralCode}`;

//   const canInvite = status === "approved" && level < 3;

//   const handleCopy = (which, text) => {
//     navigator.clipboard.writeText(text);
//     setCopied((c) => ({ ...c, [which]: true }));
//     setTimeout(() => setCopied((c) => ({ ...c, [which]: false })), 2000);
//   };

//   const handleShare = async (title, text, url) => {
//     try {
//       if (navigator.share) {
//         await navigator.share({ title, text, url });
//       } else {
//         await navigator.clipboard.writeText(url);
//         // optional toast could be added here
//       }
//     } catch {
//       // ignore
//     }
//   };

//   return (
//     <div
//       className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-[#B721FF] via-[#21D4FD] to-[#21D4FD]/90"
//       style={{ minHeight: "100vh" }}
//     >
//       <div className="w-full max-w-5xl bg-white/80 shadow-2xl rounded-3xl p-8 md:p-12 flex flex-col items-center border border-white/20">
//         <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A237E] mb-4 text-center drop-shadow-lg">
//           Your Sales Agent Dashboard
//         </h2>

//         {/* Top badges */}
//         <div className="mb-6 flex flex-col md:flex-row w-full items-center gap-4">
//           <div className="flex-1 flex flex-col items-center md:items-start">
//             <div className="flex items-center gap-3">
//               <span className="px-4 py-1 rounded-xl bg-[#B721FF]/10 text-[#B721FF] font-bold text-base">
//                 Referral Level {level}
//               </span>
//               <span className="font-semibold text-gray-800">
//                 Referral Code:
//               </span>
//               <span className="px-3 py-1 bg-gray-100 rounded-lg font-mono text-lg text-blue-800">
//                 {referralCode}
//               </span>
//             </div>
//           </div>

//           {/* Sales Agent Invite (Agents/Customers) */}
//           {canInvite && (
//             <div className="flex-1 flex flex-col md:items-end items-center w-full">
//               <div className="font-semibold text-gray-700 mb-1">
//                 Your Sales Agent Link:
//               </div>
//               <div className="flex items-center gap-2 w-full max-w-md">
//                 <input
//                   className="w-full px-3 py-2 border rounded-xl font-mono bg-gray-100"
//                   value={referralLink}
//                   readOnly
//                 />
//                 <button
//                   onClick={() => handleCopy("agent", referralLink)}
//                   className="px-4 py-2 bg-gradient-to-r from-[#B721FF] to-[#21D4FD] text-white rounded-xl font-bold shadow hover:opacity-80"
//                   type="button"
//                 >
//                   {copied.agent ? "Copied!" : "Copy"}
//                 </button>
//                 <button
//                   onClick={() =>
//                     handleShare(
//                       "Join TX TradeMart",
//                       "Sign up with my Sales Agent link:",
//                       referralLink
//                     )
//                   }
//                   className="px-4 py-2 bg-white border border-[#B721FF]/40 text-[#1A237E] rounded-xl font-semibold hover:bg-gray-50"
//                   type="button"
//                 >
//                   Share
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Instructor Invite Block */}
//         {status !== "approved" && level < 3 && (
//           <div className="mb-4 text-yellow-600 font-bold text-center">
//             Your KYC is not approved yet.
//             <br />
//             <span className="text-gray-700 font-normal">
//               Please wait for admin approval to get your referral links.
//             </span>
//           </div>
//         )}

//         {level >= 3 && (
//           <div className="mb-6 text-yellow-600 font-bold text-center">
//             You have reached Level 3.
//             <br />
//             <span className="text-gray-700 font-normal">
//               You can’t invite new Sales Agents or Instructors, but you can
//               still sell products!
//             </span>
//           </div>
//         )}

//         {/* Only show Instructor link if approved and level < 3 */}
//         {canInvite && (
//           <div className="w-full mt-2 mb-6">
//             <h4 className="text-lg font-bold mb-2 text-[#B721FF]">
//               Invite Instructors
//             </h4>
//             <div className="rounded-2xl shadow bg-white/90 p-4">
//               <p className="text-gray-700 mb-3">
//                 Share this link to invite instructors to register under you:
//               </p>
//               <div className="flex items-center gap-2 w-full max-w-2xl">
//                 <input
//                   className="w-full px-3 py-2 border rounded-xl font-mono bg-gray-100"
//                   value={instructorReferralLink}
//                   readOnly
//                 />
//                 <button
//                   onClick={() =>
//                     handleCopy("instructor", instructorReferralLink)
//                   }
//                   className="px-4 py-2 bg-gradient-to-r from-[#B721FF] to-[#21D4FD] text-white rounded-xl font-bold shadow hover:opacity-80"
//                   type="button"
//                 >
//                   {copied.instructor ? "Copied!" : "Copy"}
//                 </button>
//                 <button
//                   onClick={() =>
//                     handleShare(
//                       "Become a TX TradeMart Instructor",
//                       "Register as an instructor with my referral link:",
//                       instructorReferralLink
//                     )
//                   }
//                   className="px-4 py-2 bg-white border border-[#B721FF]/40 text-[#1A237E] rounded-xl font-semibold hover:bg-gray-50"
//                   type="button"
//                 >
//                   Share
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Downlines Table */}
//         <div className="w-full mt-4">
//           <h4 className="text-lg font-bold mb-2 text-[#B721FF]">
//             Your Sales Agents
//           </h4>
//           <div className="rounded-2xl shadow bg-white/90 p-3 overflow-x-auto min-h-[180px]">
//             {downlines.length === 0 ? (
//               <div className="text-gray-400 text-center py-6">
//                 No downline users yet.
//               </div>
//             ) : (
//               <table className="w-full text-sm">
//                 <thead>
//                   <tr className="text-[#B721FF] font-bold">
//                     <th className="py-2 px-3 text-left">Name</th>
//                     <th className="py-2 px-3">Email</th>
//                     <th className="py-2 px-3 text-center">Level</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {downlines.map((u, idx) => (
//                     <tr key={idx} className="border-b last:border-b-0">
//                       <td className="py-2 px-3">{u.fullName}</td>
//                       <td className="py-2 px-3">{u.email}</td>
//                       <td className="py-2 px-3 text-center">{u.level}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReferralPage;

// export default ReferralPage;
import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthProvider";
import { db } from "../firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { getDirectReferrals } from "../utils/referrals";

const ReferralPage = () => {
  const { user, authLoading } = useAuth();
  const [userData, setUserData] = useState(null);
  const [downlines, setDownlines] = useState([]);
  const [referredInstructors, setReferredInstructors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState({ agent: false, instructor: false });

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      const ref = doc(db, "referral_users", user.uid);
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        setUserData(null);
        setLoading(false);
        return;
      }
      const userDoc = snap.data();
      setUserData(userDoc);

      // Fetch level 1 (direct) referrals
      const level1 = await getDirectReferrals(userDoc.referralCode);

      // Fetch level 2 (indirect) referrals
      let level2 = [];
      for (let l1 of level1) {
        const l2 = await getDirectReferrals(l1.referralCode);
        level2 = level2.concat(l2);
      }

      // Fetch level 3 (third-level) referrals
      let level3 = [];
      for (let l2 of level2) {
        const l3 = await getDirectReferrals(l2.referralCode);
        level3 = level3.concat(l3);
      }

      setDownlines([
        ...level1.map((u) => ({ ...u, level: 1 })),
        ...level2.map((u) => ({ ...u, level: 2 })),
        ...level3.map((u) => ({ ...u, level: 3 })),
      ]);
      setLoading(false);
    };
    fetchData();
  }, [user, authLoading]);

  // NEW: fetch instructors who registered with this user's referral
  useEffect(() => {
    if (!user || !userData?.referralCode) return;

    const loadInstructors = async () => {
      try {
        const code = (userData.referralCode || "").trim();
        const uid = user.uid;

        const base = collection(db, "users");

        // by referrer UID
        const q1 = query(
          base,
          where("role", "==", "instructor"),
          where("referredByUid", "==", uid)
        );

        // by referral code
        const q2 = query(
          base,
          where("role", "==", "instructor"),
          where("referredByReferralCode", "==", code)
        );

        const [s1, s2] = await Promise.all([getDocs(q1), getDocs(q2)]);
        const map = new Map();
        s1.forEach((d) => map.set(d.id, { id: d.id, ...d.data() }));
        s2.forEach((d) => map.set(d.id, { id: d.id, ...d.data() }));
        setReferredInstructors(Array.from(map.values()));
      } catch (e) {
        // silent fail to keep UI calm
        setReferredInstructors([]);
      }
    };

    loadInstructors();
  }, [user, userData]);

  if (authLoading) return <div className="p-8">Loading authentication…</div>;
  if (!user)
    return <div className="p-8 text-red-600">Please login to continue</div>;
  if (loading) return <div className="p-8">Loading user data…</div>;
  if (!userData) return <div className="p-8 text-red-600">User not found</div>;

  const { referralCode, level = 1, status } = userData;

  const referralLink = `https://partners.ceylonwebmall.com/register?ref=${referralCode}`;
  const instructorReferralLink = `https://myshop.ceylonwebmall.com/register?ref=${referralCode}`;
  const canInvite = status === "approved" && level < 3;

  const handleCopy = (which, text) => {
    navigator.clipboard.writeText(text);
    setCopied((c) => ({ ...c, [which]: true }));
    setTimeout(() => setCopied((c) => ({ ...c, [which]: false })), 2000);
  };

  const handleShare = async (title, text, url) => {
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
      } else {
        await navigator.clipboard.writeText(url);
      }
    } catch {
      // ignore
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-[#B721FF] via-[#21D4FD] to-[#21D4FD]/90"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-full max-w-5xl bg-white/80 shadow-2xl rounded-3xl p-8 md:p-12 flex flex-col items-center border border-white/20">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A237E] mb-4 text-center drop-shadow-lg">
          Your Sales Agent Dashboard
        </h2>

        {/* Top badges */}
        <div className="mb-6 flex flex-col md:flex-row w-full items-center gap-4">
          <div className="flex-1 flex flex-col items-center md:items-start">
            <div className="flex items-center gap-3">
              <span className="px-4 py-1 rounded-xl bg-[#B721FF]/10 text-[#B721FF] font-bold text-base">
                Referral Level {level}
              </span>
              <span className="font-semibold text-gray-800">
                Referral Code:
              </span>
              <span className="px-3 py-1 bg-gray-100 rounded-lg font-mono text-lg text-blue-800">
                {referralCode}
              </span>
            </div>
          </div>

          {/* Sales Agent Invite (Agents/Customers) */}
          {canInvite && (
            <div className="flex-1 flex flex-col md:items-end items-center w-full">
              <div className="font-semibold text-gray-700 mb-1">
                Your Sales Agent Link:
              </div>
              <div className="flex items-center gap-2 w-full max-w-md">
                <input
                  className="w-full px-3 py-2 border rounded-xl font-mono bg-gray-100"
                  value={referralLink}
                  readOnly
                />
                <button
                  onClick={() => handleCopy("agent", referralLink)}
                  className="px-4 py-2 bg-gradient-to-r from-[#B721FF] to-[#21D4FD] text-white rounded-xl font-bold shadow hover:opacity-80"
                  type="button"
                >
                  {copied.agent ? "Copied!" : "Copy"}
                </button>
                <button
                  onClick={() =>
                    handleShare(
                      "Join Ceylon Web Mall",
                      "Sign up with my Sales Agent link:",
                      referralLink
                    )
                  }
                  className="px-4 py-2 bg-white border border-[#B721FF]/40 text-[#1A237E] rounded-xl font-semibold hover:bg-gray-50"
                  type="button"
                >
                  Share
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Instructor Invite Block */}
        {status !== "approved" && level < 3 && (
          <div className="mb-4 text-yellow-600 font-bold text-center">
            Your KYC is not approved yet.
            <br />
            <span className="text-gray-700 font-normal">
              Please wait for admin approval to get your referral links.
            </span>
          </div>
        )}

        {level >= 3 && (
          <div className="mb-6 text-yellow-600 font-bold text-center">
            You have reached Level 3.
            <br />
            <span className="text-gray-700 font-normal">
              You can’t invite new Sales Agents or Instructors, but you can
              still sell products!
            </span>
          </div>
        )}

        {/* Only show Instructor link if approved and level < 3 */}
        {canInvite && (
          <div className="w-full mt-2 mb-6">
            <h4 className="text-lg font-bold mb-2 text-[#B721FF]">
              Invite Instructors
            </h4>
            <div className="rounded-2xl shadow bg-white/90 p-4">
              <p className="text-gray-700 mb-3">
                Share this link to invite instructors to register under you:
              </p>
              <div className="flex items-center gap-2 w-full max-w-2xl">
                <input
                  className="w-full px-3 py-2 border rounded-xl font-mono bg-gray-100"
                  value={instructorReferralLink}
                  readOnly
                />
                <button
                  onClick={() =>
                    handleCopy("instructor", instructorReferralLink)
                  }
                  className="px-4 py-2 bg-gradient-to-r from-[#B721FF] to-[#21D4FD] text-white rounded-xl font-bold shadow hover:opacity-80"
                  type="button"
                >
                  {copied.instructor ? "Copied!" : "Copy"}
                </button>
                <button
                  onClick={() =>
                    handleShare(
                      "Become a Ceylon Web Mall Instructor",
                      "Register as an instructor with my referral link:",
                      instructorReferralLink
                    )
                  }
                  className="px-4 py-2 bg-white border border-[#B721FF]/40 text-[#1A237E] rounded-xl font-semibold hover:bg-gray-50"
                  type="button"
                >
                  Share
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Downlines Table */}
        <div className="w-full mt-4">
          <h4 className="text-lg font-bold mb-2 text-[#B721FF]">
            Your Sales Agents
          </h4>
          <div className="rounded-2xl shadow bg-white/90 p-3 overflow-x-auto min-h-[180px]">
            {downlines.length === 0 ? (
              <div className="text-gray-400 text-center py-6">
                No downline users yet.
              </div>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-[#B721FF] font-bold">
                    <th className="py-2 px-3 text-left">Name</th>
                    <th className="py-2 px-3">Email</th>
                    <th className="py-2 px-3 text-center">Level</th>
                  </tr>
                </thead>
                <tbody>
                  {downlines.map((u, idx) => (
                    <tr key={idx} className="border-b last:border-b-0">
                      <td className="py-2 px-3">{u.fullName}</td>
                      <td className="py-2 px-3">{u.email}</td>
                      <td className="py-2 px-3 text-center">{u.level}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* NEW: Referred Instructors */}
        <div className="w-full mt-6">
          <h4 className="text-lg font-bold mb-2 text-[#B721FF]">
            Your Instructors
          </h4>
          <div className="rounded-2xl shadow bg-white/90 p-3 overflow-x-auto min-h-[140px]">
            {referredInstructors.length === 0 ? (
              <div className="text-gray-400 text-center py-6">
                No instructors referred yet.
              </div>
            ) : (
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-[#B721FF] font-bold">
                    <th className="py-2 px-3 text-left">Name</th>
                    <th className="py-2 px-3">Email</th>
                    <th className="py-2 px-3 text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {referredInstructors.map((u) => (
                    <tr key={u.id} className="border-b last:border-b-0">
                      <td className="py-2 px-3">{u.fullName || "—"}</td>
                      <td className="py-2 px-3">{u.email || "—"}</td>
                      <td className="py-2 px-3 text-center">
                        <span className="px-2 py-0.5 rounded-full text-xs bg-gray-100">
                          {u.status || "pending"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralPage;
